<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('trackingPointsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="tracking-points-workspace">
      <mat-card class="tracking-points-routes">
        <div class="tracking-points-routes__body">
          <div class="tracking-points-routes__map-shell tracking-points-routes__map-shell--expanded">
            <div class="tracking-points-routes__map-sidebar">
            <aside class="tracking-points-routes__filter-card"
                   [class.tracking-points-routes__filter-card--collapsed]="!isFilterPanelExpanded">
              <div class="tracking-points-routes__filter-title">
                <span class="tracking-points-routes__filter-title-icon"><mat-icon>route</mat-icon></span>
                <div>
                  <small>{{ 'trackingPointsCatalog.filters.searchTitle' | translate }}</small>
                  <strong>{{ 'trackingPointsCatalog.map.title' | translate }}</strong>
                </div>
                <button
                  mat-icon-button
                  type="button"
                  class="tracking-points-routes__filter-collapse"
                  (click)="toggleFilterPanel()"
                  [attr.aria-expanded]="isFilterPanelExpanded">
                  <mat-icon>{{ isFilterPanelExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  class="tracking-points-routes__header-refresh"
                  (click)="refreshAll()"
                  [disabled]="isLoading || isMapLoading || !hasCompleteSearchCriteria"
                  [attr.aria-label]="'common.update' | translate"
                  [attr.title]="'common.update' | translate">
                  <mat-icon>refresh</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  class="tracking-points-routes__header-clear"
                  (click)="clearFilters()"
                  [disabled]="isLoading || isMapLoading || !hasActiveFilters"
                  [attr.aria-label]="'masterTable.clearFilters' | translate"
                  [attr.title]="'masterTable.clearFilters' | translate">
                  <mat-icon>filter_alt_off</mat-icon>
                </button>
              </div>
              <div class="tracking-points-routes__filters">
                @if (companies.length > 1) {
                <app-company-select class="w-100 tracking-points-routes__filter-field" [records]="companies"
                                    [value]="$any(activeFilters['company']) || ''" [includeAll]="true"
                                    [label]="'orgUnitsCatalog.fields.company' | translate"
                                    [placeholder]="'common.all' | translate" [allLabel]="'common.all' | translate"
                                    (valueChange)="onCompanyChanged($event)" />
                }
                <mat-form-field appearance="outline"
                                subscriptSizing="dynamic"
                                class="w-100 tracking-points-routes__filter-field">
                  <mat-label>{{ 'trackingPointsCatalog.filters.employee' | translate }}</mat-label>
                  <input matInput
                         #employeeTrigger="matAutocompleteTrigger"
                         [ngModel]="employeeSearchText"
                         (ngModelChange)="onEmployeeSearchInput($event)"
                         [matAutocomplete]="employeeAutocomplete"
                         [placeholder]="'trackingPointsCatalog.filters.employeePlaceholder' | translate"
                         autocomplete="off"
                         (focus)="employeeTrigger.openPanel()"
                         (click)="employeeTrigger.openPanel()" />
                  <button mat-icon-button
                          matSuffix
                          type="button"
                          tabindex="-1"
                          (click)="employeeTrigger.openPanel()">
                    <mat-icon>badge</mat-icon>
                  </button>
                  <mat-autocomplete #employeeAutocomplete="matAutocomplete"
                                    [displayWith]="displayEmployeeOption"
                                    (optionSelected)="onEmployeeSelected($event.option.value)">
                    @for (employee of filteredEmployees; track employee.employeeId) {
                    <mat-option [value]="employee">
                      <div class="tracking-points-routes__employee-option">
                        <span>{{ getEmployeeInitials(employee) }}</span>
                        <div>
                          <strong>{{ employee.fullName || employee.employeeNumber }}</strong>
                          <small>{{ employee.employeeNumber || employee.employeeId }}</small>
                        </div>
                      </div>
                    </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>

                <div class="tracking-points-routes__date-navigation">
                  <button type="button" (click)="shiftSelectedDate(-1)" [attr.title]="'trackingPointsCatalog.filters.previousDay' | translate">
                    <mat-icon>chevron_left</mat-icon>
                  </button>
                  <app-date-time-picker-field class="w-100 tracking-points-routes__filter-field"
                                              [label]="'trackingPointsCatalog.filters.dateFrom' | translate"
                                              [value]="dateFrom"
                                              mode="date"
                                              [placeholder]="'trackingPointsCatalog.filters.dateFrom' | translate"
                                              (valueChange)="onDateFromInput($event)">
                  </app-date-time-picker-field>
                  <button type="button" (click)="shiftSelectedDate(1)" [attr.title]="'trackingPointsCatalog.filters.nextDay' | translate">
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                </div>
              </div>

              @if (isLoading || isMapLoading) {
                <div class="tracking-points-routes__filter-progress"><i></i></div>
              }

              <footer class="tracking-points-routes__filter-summary">
                <span>
                  <mat-icon>calendar_today</mat-icon>
                  {{ selectedDateRangeLabel === '-' ? ('trackingPointsCatalog.filters.noDate' | translate) : selectedDateRangeLabel }}
                </span>
                <strong><mat-icon>location_on</mat-icon>{{ 'trackingPointsCatalog.map.legendPoints' | translate:{ count: routeSummary.totalPoints } }}</strong>
              </footer>
              @if (hasRouteData) {
                <div class="tracking-points-routes__route-stats">
                  <span><small>{{ 'trackingPointsCatalog.map.timelineStart' | translate }}</small><strong>{{ routeSummary.startLabel }}</strong></span>
                  <span><small>{{ 'trackingPointsCatalog.map.timelineEnd' | translate }}</small><strong>{{ routeSummary.endLabel }}</strong></span>
                  <span><small>{{ 'trackingPointsCatalog.map.summaryDuration' | translate }}</small><strong>{{ routeSummary.durationLabel }}</strong></span>
                  <span><small>{{ 'trackingPointsCatalog.map.summaryDistance' | translate }}</small><strong>{{ routeSummary.distanceLabel }}</strong></span>
                </div>
              }
            </aside>

            <section class="tracking-points-routes__comparison-legend"
                     [class.tracking-points-routes__comparison-legend--expanded]="isLegendExpanded">
              <button type="button"
                      class="tracking-points-routes__legend-toggle"
                      [attr.aria-expanded]="isLegendExpanded"
                      (click)="isLegendExpanded = !isLegendExpanded">
                <mat-icon>{{ isLegendExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                <span>
                  <strong>{{ legendTitleLabel }}</strong>
                  <small>{{ legendDetailsLabel }}</small>
                </span>
                <mat-icon class="tracking-points-routes__legend-info">info</mat-icon>
              </button>
              @if (isLegendExpanded) {
              <div class="tracking-points-routes__legend-details">
              <div class="tracking-points-routes__comparison-item">
                <span class="tracking-points-routes__comparison-line tracking-points-routes__comparison-line--processed"></span>
                <span>{{ 'trackingPointsCatalog.map.processedRoute' | translate }}</span>
              </div>
              <div class="tracking-points-routes__comparison-item">
                <span class="tracking-points-routes__comparison-line tracking-points-routes__comparison-line--raw"></span>
                <span>{{ 'trackingPointsCatalog.map.rawRoute' | translate }}</span>
              </div>
              <div class="tracking-points-routes__comparison-item tracking-points-routes__comparison-item--endpoint">
                <span class="tracking-points-routes__comparison-endpoint tracking-points-routes__comparison-endpoint--start">A</span>
                <span>{{ 'trackingPointsCatalog.map.timelineStart' | translate }}</span>
              </div>
              <div class="tracking-points-routes__comparison-item tracking-points-routes__comparison-item--endpoint">
                <span class="tracking-points-routes__comparison-endpoint tracking-points-routes__comparison-endpoint--end">B</span>
                <span>{{ 'trackingPointsCatalog.map.timelineEnd' | translate }}</span>
              </div>
              <div class="tracking-points-routes__comparison-item tracking-points-routes__comparison-item--compact">
                <span class="tracking-points-routes__comparison-arrow">▲</span>
                <span>{{ 'trackingPointsCatalog.map.direction' | translate }}</span>
              </div>
              @if (detectedStops > 0) {
              <div class="tracking-points-routes__comparison-item tracking-points-routes__comparison-item--compact">
                <span class="tracking-points-routes__comparison-stop">Ⅱ</span>
                <span>{{ 'trackingPointsCatalog.map.stopsDetected' | translate:{ count: detectedStops } }}</span>
              </div>
              }
              @if (detectedCuts > 0) {
              <div class="tracking-points-routes__comparison-item tracking-points-routes__comparison-item--compact">
                <span class="tracking-points-routes__comparison-cut"><i>C</i><i>C</i></span>
                <span>{{ 'trackingPointsCatalog.map.cutsDetected' | translate:{ count: detectedCuts } }}</span>
              </div>
              }
              <small>{{ osrmProfileLabel }}</small>
              @if (processedRoutePending > 0) {
              <small class="tracking-points-routes__osrm-status tracking-points-routes__osrm-status--loading">
                {{ 'trackingPointsCatalog.map.osrmProcessing' | translate }}
              </small>
              } @else if (processedRouteSegments > 0) {
              <small class="tracking-points-routes__osrm-status tracking-points-routes__osrm-status--success">
                {{ 'trackingPointsCatalog.map.osrmMatched' | translate:{ count: processedRouteSegments } }}
              </small>
              } @else if (processedRouteFailures > 0) {
              <small class="tracking-points-routes__osrm-status tracking-points-routes__osrm-status--error">
                {{ 'trackingPointsCatalog.map.osrmNoMatch' | translate }}
              </small>
              }
              @if (kalmanFallbackSegments > 0) {
              <small class="tracking-points-routes__osrm-status tracking-points-routes__osrm-status--loading">
                {{ 'trackingPointsCatalog.map.kalmanFallback' | translate:{ count: kalmanFallbackSegments } }}
              </small>
              }
              </div>
              }
            </section>
            </div>

            <div class="tracking-points-routes__map-toolbar">
              @if (hasRouteData) {
              <div class="tracking-points-routes__map-actions">
                <button type="button" (click)="fitRouteOnMap()" [attr.title]="'trackingPointsCatalog.map.fitRoute' | translate"><mat-icon>zoom_out_map</mat-icon></button>
                <button type="button" (click)="focusRouteEndpoint('start')" [attr.title]="'trackingPointsCatalog.map.goToStart' | translate"><span>A</span></button>
                <button type="button" (click)="focusRouteEndpoint('end')" [attr.title]="'trackingPointsCatalog.map.goToEnd' | translate"><span>B</span></button>
                <button type="button" [class.active]="showRawRoute" (click)="toggleRawRoute()" [attr.title]="'trackingPointsCatalog.map.toggleRawRoute' | translate"><mat-icon>timeline</mat-icon></button>
              </div>
              }
              <button type="button"
                      class="tracking-points-routes__live-btn"
                      [class.tracking-points-routes__live-btn--active]="isLiveTracking"
                      (click)="toggleLiveTracking()">
                <span class="tracking-points-routes__live-dot"></span>
                <span>{{ (isLiveTracking ? 'trackingPointsCatalog.map.liveOn' : 'trackingPointsCatalog.map.liveOff') | translate }}</span>
                @if (lastLiveRefreshAt && isLiveTracking) {
                <small>{{ lastLiveRefreshAt | date:'HH:mm:ss' }}</small>
                }
              </button>
            </div>

            <div #routesMap
                 class="tracking-points-routes__map"></div>
            @if (isMapLoading) {
            <div class="tracking-points-routes__overlay">
              <mat-icon>route</mat-icon>
              <span>{{ 'trackingPointsCatalog.map.loading' | translate }}</span>
            </div>
            }
            @if (!isMapLoading && !hasRouteData) {
            <div class="tracking-points-routes__overlay tracking-points-routes__overlay--empty">
              <mat-icon>{{ hasCompleteSearchCriteria ? 'route' : 'travel_explore' }}</mat-icon>
              <strong>{{ (hasCompleteSearchCriteria ? 'trackingPointsCatalog.map.emptyTitle' : 'trackingPointsCatalog.map.searchPromptTitle') | translate }}</strong>
              <span>{{ (hasCompleteSearchCriteria ? 'trackingPointsCatalog.map.emptyDescription' : 'trackingPointsCatalog.map.searchPromptDescription') | translate }}</span>
            </div>
            }
            @if (hasTimelineData) {
            <div class="tracking-points-routes__timeline-shell tracking-points-routes__timeline-shell--dock">
            <div class="tracking-points-routes__playback-bar">
              <button type="button"
                      class="tracking-points-routes__playback-toggle"
                      [attr.aria-label]="(isPlaybackPlaying ? 'trackingPointsCatalog.map.playbackPause' : 'trackingPointsCatalog.map.playbackPlay') | translate"
                      (click)="togglePlayback()">
                <mat-icon>{{ isPlaybackPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
              </button>

              <div class="tracking-points-routes__playback-status">
                <span>
                  <small>{{ 'trackingPointsCatalog.map.playbackTime' | translate }}</small>
                  <strong>{{ playbackTimeLabel }}</strong>
                </span>
                <span>
                  <small>{{ 'trackingPointsCatalog.map.playbackSpeed' | translate }}</small>
                  <strong>{{ playbackCurrentSpeedLabel }}</strong>
                </span>
              </div>

              <div class="tracking-points-routes__playback-rates"
                   [attr.aria-label]="'trackingPointsCatalog.map.playbackRate' | translate">
                @for (rate of playbackRates; track rate) {
                <button type="button"
                        [class.active]="playbackRate === rate"
                        (click)="setPlaybackRate(rate)">{{ rate }}×</button>
                }
              </div>

              <button type="button"
                      class="tracking-points-routes__playback-follow"
                      [class.active]="playbackFollowEnabled"
                      [attr.aria-label]="'trackingPointsCatalog.map.playbackFollow' | translate"
                      (click)="togglePlaybackFollow()">
                <mat-icon>{{ playbackFollowEnabled ? 'my_location' : 'location_disabled' }}</mat-icon>
                <span>{{ 'trackingPointsCatalog.map.playbackFollow' | translate }}</span>
              </button>
            </div>
            <div class="tracking-points-routes__timeline-control">
              <button type="button"
                      class="tracking-points-routes__timeline-nav"
                      [disabled]="playbackPosition <= 0"
                      (click)="selectPreviousTimelinePoint()">
                <mat-icon>chevron_left</mat-icon>
              </button>

              <div class="tracking-points-routes__timeline-progress">
                <div class="tracking-points-routes__timeline-track">
                  <div class="tracking-points-routes__timeline-track-fill"
                       [style.width.%]="playbackProgressPercent"></div>
                </div>

                <input type="range"
                       class="tracking-points-routes__timeline-slider"
                       [min]="0"
                       [max]="timelinePoints.length - 1"
                       [step]="0.01"
                       [ngModel]="playbackPosition"
                       (ngModelChange)="onTimelineSliderChange($event)">

                <div class="tracking-points-routes__timeline-endpoints">
                  <span class="tracking-points-routes__timeline-endpoint tracking-points-routes__timeline-endpoint--start">
                    {{ 'trackingPointsCatalog.map.timelineStart' | translate }}
                  </span>
                  <span class="tracking-points-routes__timeline-endpoint tracking-points-routes__timeline-endpoint--end">
                    {{ 'trackingPointsCatalog.map.timelineEnd' | translate }}
                  </span>
                </div>
              </div>

              <button type="button"
                      class="tracking-points-routes__timeline-nav"
                      [disabled]="playbackPosition >= timelinePoints.length - 1"
                      (click)="selectNextTimelinePoint()">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
            </div>
            }
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</section>
